import { Card, Row, Col } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import NumberFormat from 'react-number-format';
import { Divider } from "antd";
/* import logosetab from '../assets/images/logosetab.png'; */
import { useSelector, useDispatch } from 'react-redux';
import { actpag, acttotpag } from '../features/ctdata/pagSlice';
import '../assets/styles/C911Ced.scss';
//import { ContactsOutlined } from '@material-ui/icons';

export function CabezaCedula(){
return(
    <Row>
        <Col xs={5}><div className="p-1"><img className="logoced" src="https://estadisticas.setab.gob.mx/imagenes/SETAB_logo.png" alt=""></img></div></Col>
        <Col xs={7}><div className="p-3 text-center font-weight-bold"><p className="titprinc">CÉDULA DE ESTADÍSTICA DE CENTRO EDUCATIVO</p></div></Col>
    </Row>
);
}

export function IdentEsc(){
    const { estad,fechacct,fechac911 } = useSelector((state) => state.esc);
    let subnivel='';
    let nivsubniv='';
    let clasif=(estad[0].cvect).substring(2,5);
    let fuentesost='';
    switch (clasif){
        case 'MMS':
            subnivel='MEDIA SUPERIOR';
            break;
        case 'MSU':
            subnivel='SUPERIOR';
            break;
        default:
            if ((estad[0].nivel).toUpperCase()!==(estad[0].subnivel).toUpperCase()){
                subnivel=" ("+estad[0].subnivel+")";
            }
    }
    nivsubniv=estad[0].nivel+subnivel;
    if (fechac911[0].fuente==="ESTADIS"){
        fuentesost='* Correspondiente al corte del levantamiento estadístico.';
    }
return(
    <div>
        <Card border="dark" style={{ width: 'auto' }}>
            <Card.Header className="text-center font-weight-bold">IDENTIFICACIÓN Y UBICACIÓN</Card.Header>
            <Card.Body>
            <Row>
                <Col xs={3}>Clave del CT</Col>
                <Col xs={5}>Turno</Col>
                <Col xs={4}>Nivel (subnivel)</Col>
            </Row>
            <Row>
                <Col xs={3}><div className="borde"><p>{estad[0].cvect}</p></div></Col>
                <Col xs={5}><div className="borde"><p>{estad[0].turnocomb}</p></div></Col>
                <Col xs={4}>
                    <div className="borde" style={{display:'flex',alignContent:'space-between',alignItems: 'center'}}>
                        <p style={{fontSize:`${AjustaFuenteTexto(nivsubniv.length,35)}`}}>{nivsubniv}</p>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={8}>Nombre</Col>
                <Col xs={4}>Sostenimiento (*)</Col>
            </Row>
            <Row>
                <Col xs={8}>
                    <div className="borde" style={{display:'flex',alignContent:'space-between',alignItems: 'center'}}>
                        <p style={{fontSize:`${AjustaFuenteTexto(estad[0].nomct.length,100)}`}}>{estad[0].nomct}</p>
                    </div>
                </Col>
                <Col xs={4}><div className="borde"><p>{estad[0].sost}</p></div></Col>    
            </Row>
            <Row>
                <Col xs={8}>Domicilio</Col>
                <Col xs={4}>Director (a)</Col>
            </Row>
            <Row>
                <Col xs={8}>
                    <div className="borde" style={{display:'flex',alignContent:'space-between',alignItems: 'center'}}>
                        <p style={{fontSize:`${AjustaFuenteTexto(estad[0].dom.length,75)}`}}>{estad[0].dom}</p>
                    </div>
                </Col>
                <Col xs={4}>
                    <div className="borde" style={{display:'flex',alignContent:'space-between',alignItems: 'center'}}>
                        <p style={{fontSize:`${AjustaFuenteTexto(estad[0].contacto.length,35)}`}}>{estad[0].contacto}</p>
                    </div>
                </Col>    
            </Row>
            <Row>
                <Col xs={8}>Localidad</Col>
            {/* <Col xs={2}>Tel.</Col> */}
            {/* <Col xs={2}>Cel</Col> */}
            </Row>
            <Row>
                <Col xs={8}><div className="borde"><p>{estad[0].cveloc}-{estad[0].nomloc}</p></div></Col>
            {/* <Col xs={2}><div className="borde"><p>{estad[0].tel}</p></div></Col> */}
            {/* <Col xs={2}><div className="borde"><p>{estad[0].cel}</p></div></Col> */}
            </Row>
            <Row>
                <Col xs={3}>Municipio</Col>
                <Col xs={3}>Unidad Regional</Col>
                <Col xs={1} className="text-center">Zona</Col>
                <Col xs={1} className="text-center">Sector</Col>
            {/*    <Col xs={4}>E-Mail</Col> */}
            </Row>
            <Row>
                <Col xs={3}><div className="borde"><p>{estad[0].cvemun}-{estad[0].nommun}</p></div></Col>
                <Col xs={3}><div className="borde"><p>{estad[0].nomregion}</p></div></Col>
                <Col xs={1} className="text-center"><div className="borde"><p>{estad[0].numzona}</p></div></Col>
                <Col xs={1} className="text-center"><div className="borde"><p>{estad[0].numsector}</p></div></Col>
            {/* <Col xs={4}><div className="borde"><p>{estad[0].email}</p></div></Col> */}
            </Row>
            <Row className="no-gutters" style={{marginTop:'0.6rem'}}>
                <Col>
                    <Row className="no-gutters sin-borde-altura">
                        <Col xs={7} className="fontmaspeque text-left textoBottom">
                            <p><b>Fuente:</b> Catálogo de Centros de Trabajo con corte al {FechActDatos(fechacct)}.</p>
                        </Col>
                        <Col xs={5} className="fontmaspeque text-right textoBottom" style={{paddingLeft:'4.5rem'}}>
                            <p>{fuentesost}</p>                            
                        </Col>
                    </Row>
                </Col>
            </Row>            
            </Card.Body>
        </Card>
        <Row><Col><div className="renglonvacio"></div></Col></Row>
    </div>
);
}
export function VersionCifras(){
    const { fechac911 } = useSelector((state) => state.esc);
    let version='';
    switch (fechac911[0].fuente){
        case 'CONTROL':
            version="CIFRAS PRELIMINARES";
            break;
        case 'ESTADIS':
            if(fechac911[0].veredo==="AP") {
                version="CIFRAS PRELIMINARES DE LA ";
            }
            break;
        default:
            version="SIN VERSIÓN DE CIFRAS";
    }
    return version;
}

export function PieCedula(){
    const dispatch = useDispatch();
    dispatch(actpag());
    const { fechac911 } = useSelector((state) => state.esc);
    let version='';
    let descrdatos='';
    let fechadatos='';
    let corteprelim='';
    switch (fechac911[0].fuente){
        case 'CONTROL':
            version="Cifras Preliminares";
            descrdatos='Los datos estadísticos de docentes, aulas y personal por función, se mostrarán hasta oficializarlos ante la SEP.';
            fechadatos=Fecha();
            break;
        case 'ESTADIS':
            descrdatos='Los datos de los demás servicios educativos, son los reportados en el Sistema 911 por los Titulares de los Centros de Trabajo. Corte al '+fechac911[0].fechaestad+'.';
            fechadatos=fechac911[0].fechaalum;            
            if(fechac911[0].veredo==="AP") {
                version="Cifras preliminares de la Estadística Básica";
                corteprelim=` Corte al ${fechac911[0].corteprelim}.`;
            }else{
                version="Estadística Básica";
            }
            break;
        default:
            version="SIN FUENTE DE DATOS";
    }
    return(
        <Row className="no-gutters pagebreak">
        <Col className="fontpeque">
            <Row><Col><div className="renglonvacio"></div></Col></Row>
            <Row>
            <Col xs={1} className="text-left font-weight-bold fontpeque" style={{paddingLeft:'1.5rem'}}>Fuente:</Col>
            <Col xs={11} className="text-left">
                <Row className="sin-borde-altura fontmaspeque">{version} del Sistema Educativo Estatal a Inicio de Cursos {CicloCenso(0)}.{corteprelim}</Row>
                <Row className="sin-borde-altura fontmaspeque">La matrícula y grupos en Educación Básica, (no incluyendo CONAFE) corresponden a la información obtenida de la base de datos del Sistema de Control</Row>
                <Row className="sin-borde-altura fontmaspeque">Escolar de la SETAB. Corte al {fechadatos}.</Row>
                <Row className="sin-borde-altura fontmaspeque">{descrdatos}</Row>
                <Row className="sin-borde-altura fontmaspeque">Secretaría de Educación del Estado de Tabasco. Coordinación General de Planeación, Evaluación e Infraestructura. Dirección de Planeación. Subdirección del Sistema de Información Estadística.</Row>                
            </Col>
            </Row>
            <Row>
            {/*<Col xs={6} className="text-right numpag">Hoja</Col>*/}
            <Col className="text-right"><b>Fecha de impresión</b> {Fecha()}</Col>
            </Row>
        </Col>
        </Row>
    );
}

export function PieCedulaMedia(){
    const dispatch = useDispatch();
    dispatch(actpag());
    const { fechac911 } = useSelector((state) => state.esc);
    let version='';
    let corteprelim='';
    switch (fechac911[0].fuente){
        case 'ESTADIS':        
            if(fechac911[0].veredo==="AP") {
                version="Cifras preliminares de la Estadística Básica";
                corteprelim=` Corte al ${fechac911[0].corteprelim}.`;
            }else{
                version="Estadística Básica";
            }
            break;
        default:
            version="SIN FUENTE DE DATOS";
    }
    return(
        <Row className="no-gutters pagebreak">
        <Col className="fontpeque">
            <Row><Col><div className="renglonvacio"></div></Col></Row>
            <Row>
            <Col xs={1} className="text-left font-weight-bold fontpeque" style={{paddingLeft:'1.5rem'}}>Fuente:</Col>
            <Col xs={11} className="text-left">
                <Row className="sin-borde-altura fontmaspeque">{version} del Sistema Educativo Estatal a Inicio de Cursos {CicloCenso(0)}.{corteprelim}</Row>
                <Row className="sin-borde-altura fontmaspeque">Los datos estadísticos son los reportados en el Sistema 911 por los Titulares de los Centros de Trabajo. Corte al {fechac911[0].fechaestad}.</Row>
                <Row className="sin-borde-altura fontmaspeque">Secretaría de Educación del Estado de Tabasco. Coordinación General de Planeación, Evaluación e Infraestructura. Dirección de Planeación. Subdirección del Sistema de Información Estadística.</Row>                
            </Col>
            </Row>
            <Row>
            {/*<Col xs={6} className="text-right numpag">Hoja</Col>*/}
            <Col className="text-right"><b>Fecha de impresión</b> {Fecha()}</Col>
            </Row>
        </Col>
        </Row>
    );
}

export function ClaveEsc(props){
    return(
        <Row className="no-gutters">
        <Col xs={12} className="bordetransparente text-left"><h6><Negrillas texto={'CLAVE DEL CT'}/> {props.cvect}</h6></Col>
        </Row>
    );
}

export function CicloCenso(band){
    const { fechac911 } = useSelector((state) => state.esc);
    let fecha=fechac911[0].fechaestad;
    let corte="";
    if (fecha.length===10){
        let ciclo=fecha.substr(6,4);
        /*
        if(fechac911[0].fechaestad==="30/09/2022") {
           if (band===1){
            corte=" (corte al 13/12/2022)";
           }else{
            corte=". Corte al 13/12/2022";
           }
        }
        */       
        return ciclo + "-" + (parseInt(ciclo)+1).toString()+ corte;
    }
    return ""
}

export function Separador(numreg,reg1hoja){
    /*if (numreg > reg1hoja) {
      return <Row className="lineaseparador"></Row>;
    }*/
    return "";
}
  
export function TotalAlumnos(props){
    const total = props.escuela.reduce((tot, items) => tot + parseInt(items.alumtot),0);
    return (<h5><Badge pill="true" style={{border:"0", letterSpacing:"0.05em",
    wordSpacing:"0.15em", background:"#991547", color:"white"}}>{" "}TOTAL DE ALUMNOS :{" "}
    <NumberFormat value={total} displayType={'text'} thousandSeparator={true}/>{" "}
    </Badge></h5>);
}

export function SeparaMiles(cantidad){
    return (<NumberFormat value={cantidad} displayType={'text'} thousandSeparator={true}/>);
}

export function Negrillas(props){
    return <b>{props.texto}:</b>
}

export function Fecha(){
    let hoy=new Date();
    return (hoy.getDate() + '/' + (hoy.getMonth() + 1) + '/' + hoy.getFullYear());
}

export function FechActDatos(fecha) {
    if (fecha.length===10){
      let cadfech=fecha.substr(3,2)+"/"+fecha.substr(0,2)+fecha.substr(5,5);
      let date = new Date(cadfech);
      let options = {year: 'numeric',month: 'long',day: 'numeric'};
      // weekday: 'long'
      return date.toLocaleDateString('es-mx', options)
    }
    return ""
}

export function SumaSet(props){
    let total=props.reduce(function(a, b){return parseInt(a) +parseInt(b)})
    return total
}

export function NotaAula(){
    return "(de las aulas en uso)"
}

export function TurnoNombre(props){
    let nomturno="";
    let turnoenc="";
    for (var ii=1;ii<props.length;ii++){
        nomturno=props[ii];
        if (nomturno.length>0) {
            if(nomturno.substring(0,1)===props[0]){
                turnoenc=nomturno;
                break;
            }
        }
    }
    return (<Divider orientation="left" plain style={{ borderWidth: 1, borderColor: '#991547' }}><h6><b>TURNO</b>{" "}{turnoenc}</h6></Divider>)
}

export function AjustaFuenteTexto(tamcadena,tam){
    if (tamcadena>tam){
        return "10px";
    } else {
        return "15px";
    }
}

export function ActHojas(regs,regcct,regxanexo){
    const dispatch = useDispatch();
    let numanexent=0;
    let numanexres=0;
    let regsincct=regs-regcct;
    if (regsincct>0){
        numanexent=Math.trunc(regsincct/regxanexo);
        numanexres=regsincct % regxanexo;
        if (numanexres>0){
            numanexent=numanexent+1;
        }
    }
    dispatch(acttotpag(numanexent+1));
    return ;
}
export function CortePrelim(band){
    const { fechac911 } = useSelector((state) => state.esc);
    let corte='';
    if(fechac911[0].fechaestad==="30/09/2022") {
        if (band===0) {
            corte=" Corte al 13/12/2022.";
        }else{
            corte=" (corte al 13/12/2022)";
        }        
    }
    return corte;
}